import {HorizontalList, VerticalList} from 'focus-manager/web';
import * as React from 'react';

import {alphanumericKeyset, diacriticsKeyset} from '../Constants/keysets';
import ReservedValue from '../Constants/ReservedValue';
import IKey from '../Interfaces/IKey';
import createNextValue from '../Util/createNextValue';

import Key from './Key';

const divideKeysIntoRows = (keys: IKey[]) => [keys.slice(0, 13), keys.slice(13, 28), keys.slice(28)];

const Keyboard: React.FC = () => {
    const [value, setValue] = React.useState('');
    const [keyset, setKeyset] = React.useState(alphanumericKeyset);

    const rows = React.useMemo(() => divideKeysIntoRows(keyset), [keyset]);

    const handleKeySelect = React.useCallback((keyValue: string) => {
        switch (keyValue) {
            case ReservedValue.DIACRITICS:
                setKeyset(diacriticsKeyset);

                break;
            case ReservedValue.ALPHANUMERIC:
                setKeyset(alphanumericKeyset);

                break;
            default:
                setValue(prevValue => createNextValue(prevValue, keyValue));
        }
    }, []);

    return (
        <>
            <div className="value">{value}</div>

            <VerticalList className="keyboard" justify>
                {rows.map((keys, i) => {
                    const rowClassName = ['key-wrapper', i === 0 && 'key-wrapper--centered'].filter(Boolean).join(' ');

                    return (
                        <HorizontalList className={rowClassName} key={i} loop>
                            {keys.map(key => (
                                <Key {...key} key={key.key} onSelect={handleKeySelect} />
                            ))}
                        </HorizontalList>
                    );
                })}
            </VerticalList>
        </>
    );
};

export default Keyboard;
